import type { IPromotionRepository } from '../repositories/IPromotionRepository.js';
import type { PromotionScheme } from '../entities/PromotionScheme.js';

export interface CreateSchemeUseCaseDeps {
  promotionRepository: IPromotionRepository;
}

export const createCreateSchemeUseCase = ({ promotionRepository }: CreateSchemeUseCaseDeps) => {
  return async (data: Omit<PromotionScheme, 'id' | 'created_at' | 'updated_at'>): Promise<PromotionScheme> => {
    return promotionRepository.createScheme(data);
  };
};
